const pdContent = document.querySelectorAll<HTMLElement>('.pd-content');

pdContent.forEach(async content => {
  const formFields = content.querySelectorAll<HTMLFormElement>('input, select');
  const colorsInfoRow = content.querySelector<HTMLElement>('.g-colors')?.closest('.pd-i-info');
  const inputs = content.querySelectorAll<HTMLInputElement>('input');
  const selects = content.querySelectorAll<HTMLSelectElement>('select');
  const priceElement = content.querySelector<HTMLElement>('.i-price__value[data-price]');
  const priceWithoutVatElement = content.querySelector<HTMLElement>('.i-price__value[data-price-without-vat]');
  const handlePriceUrl = content.querySelector<HTMLElement>('[data-handle-price-format-link]')?.dataset.handlePriceFormatLink;

  if (!priceElement || !priceWithoutVatElement || !formFields) return;

  const calculatePrice = async () => {
    let totalPrice = parseFloat(priceElement?.dataset.price ?? "0");
    let totalPriceWithoutVat = parseFloat(priceWithoutVatElement?.dataset.priceWithoutVat ?? "0");

    inputs.forEach(input => {
      if (!input.checked) return;
      totalPrice += input.dataset.price ? parseFloat(input.dataset.price) : 0;
      totalPriceWithoutVat += input.dataset.priceWithoutVat ? parseFloat(input.dataset.priceWithoutVat) : 0;
    })

    selects.forEach(select => {
      const options = Array.from<HTMLElement>(select.selectedOptions);

      options.forEach(option => {
        totalPrice += option.dataset.price ? parseFloat(option.dataset.price) : 0 ;
        totalPriceWithoutVat += option.dataset.priceWithoutVat ? parseFloat(option.dataset.priceWithoutVat) : 0;
      })
    })

    priceElement.innerHTML = await formatPrice(totalPrice.toString());
    priceWithoutVatElement.innerHTML = await formatPrice(totalPriceWithoutVat.toString());
  }

  const formatPrice = async (price: string) => {

    const response = await fetch(`${handlePriceUrl}/${price}`);

    if (response.ok) {
      const data = (await response.json()) as detailPrice;
      return data.priceFormatted;
    }

    return "0";
  }

  const disableColors = (disable: boolean) => {
    colorsInfoRow?.classList.toggle('--hidden', disable);
    if(disable) {
      colorsInfoRow?.querySelectorAll<HTMLInputElement>('input:checked')?.forEach(input => {
        input.checked = false;
        input.dispatchEvent(new Event('change'))
      })
    } else {
      const colorInput = colorsInfoRow?.querySelector<HTMLInputElement>('input')
      if (colorInput) colorInput.checked = true;
      colorInput?.dispatchEvent(new Event('change'))
    }

  }

  formFields.forEach(field => {
    field.addEventListener('change', async () => {
      if (field.hasAttribute('data-hide-colors-on-select')) disableColors(!!+field.dataset.hideColorsOnSelect)
      await calculatePrice()
    })

    if (field.checked) disableColors(!!+field.dataset.hideColorsOnSelect)
  })

  await calculatePrice();
})

type detailPrice = {
  priceFormatted : string
}
